import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { getClosest, getSiblings, slideToggle, slideUp } from "../../utils";
import Logo from "../logo";

const TeamInfo = ({ show, onClose, data }) => {
    const modalRef = useRef(null);

    const onClickHandler = (e) => {
        const target = e.currentTarget;
        const parentEl = target.parentElement;
        if (
            parentEl?.classList.contains("menu-expand") ||
            target.classList.contains("menu-expand")
        ) {
            const element = target.classList.contains("icon")
                ? parentEl
                : target;
            const parent = getClosest(element, "li");
            const childNodes = parent.childNodes;
            const parentSiblings = getSiblings(parent);
            parentSiblings.forEach((sibling) => {
                const sibChildNodes = sibling.childNodes;
                sibChildNodes.forEach((child) => {
                    if (child.nodeName === "UL") {
                        slideUp(child, 1000);
                    }
                });
            });
            childNodes.forEach((child) => {
                if (child.nodeName === "UL") {
                    slideToggle(child, 1000);
                }
            });
        }
    };

    useEffect(() => {
        if (show) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [show]);

    return (
        <>
            {show && (
                <div
                    className="modal-backdrop"
                    style={{
                        background: "rgba(0, 0, 0, 0.5)",
                        backdropFilter: "blur(5px)",
                    }}
                ></div>
            )}

            <div
                ref={modalRef}
                className={`modal ${show ? "show d-block" : ""}`}
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                aria-labelledby={data.name}
                aria-hidden="true"
                id={data.id}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        {/* <div className="modal-header">
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => onClose()}
                        ></button>
                    </div> */}
                        <div className="modal-body">
                            {/* <h5>...</h5> */}

                            {/* <div className="modal-content"> */}
                            <div>
                                <div className="fv-row">
                                    <div className="row">
                                        <div className="col-md-3 p-0">
                                            <div className="p-2 pt-4 d-flex justify-content-center align-items-center align-center">
                                                <img
                                                    src={
                                                        process.env.PUBLIC_URL +
                                                        data.thumb
                                                    }
                                                    alt={data.name}
                                                    className="border-radius-10 img-bottom-border shadow-lg p-3  bg-white rounded object-cover"
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "100%",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-9 pl-4 pt-4 pr-4 ">
                                            <div className="text-start">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <h2
                                                            className="b-color pt-1 fs-3"
                                                            id={data.name}
                                                        >
                                                            <b>{data?.name}</b>
                                                        </h2>
                                                        <div className="g-color pb-0">
                                                            {data?.designation}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            aria-label="Close"
                                                            onClick={() =>
                                                                onClose()
                                                            }
                                                        ></button>
                                                    </div>
                                                </div>
                                                <div className="simpleborder"></div>
                                                <ul className="text-dark fs-12 pt-3 list-items-dot">
                                                    <li className="pb-1">
                                                        {data?.details_1}
                                                    </li>
                                                    <li className="pb-1">
                                                        {data?.details_2}
                                                    </li>
                                                    <li className="pb-1">
                                                        {data?.details_3}
                                                    </li>
                                                    {data?.details_4 && (
                                                        <li className="pb-1">
                                                            {data?.details_4}
                                                        </li>
                                                    )}
                                                    {data?.details_5 && (
                                                        <li className="pb-1">
                                                            {data?.details_5}
                                                        </li>
                                                    )}
                                                </ul>
                                                {data?.linkedin && (
                                                    <a
                                                        target="_blank"
                                                        href={data?.linkedin}
                                                        rel="noreferrer"
                                                        aria-label={`Visit ${data.name} LinkedIn profile (opens in a new tab)`}
                                                    >
                                                        <i className=" text-blue fa-lg fa fa-linkedin"></i>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

TeamInfo.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    data: PropTypes.object,
};

export default TeamInfo;
